import React from 'react';
import { confirmable, ReactConfirmProps } from 'react-confirm';

import CheckBox from 'sharedreact/components/CheckBox';
import Dialog from 'sharedreact/components/Dialog';
import { translate } from 'sharedreact/utils/LanguageSupport';

type Props = ReactConfirmProps & {
  id: string,
  language: string,
  title: string,
  message: string,
  info?: string,
  yesButtonText?: string,
  noButtonText?: string,

  setDontAskAgain?: (dontAskAgain: boolean) => void,
  onClose: () => void
};

type State = {
  dontAskAgain: boolean
};

class ConfirmDialog extends React.PureComponent<Props, State> {
  constructor (props: Props) {
    super(props);

    this.state = {
      dontAskAgain: false
    };

    this.handleShown = this.handleShown.bind(this);
    this.handleDontAskAgain = this.handleDontAskAgain.bind(this);
  }

  handleShown () {
    const { id } = this.props;

    if (document.activeElement != null && document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }

    document.getElementById('ae_dialog_confirm_' + id + '_confirm')?.focus();
  }

  handleDontAskAgain (event: React.ChangeEvent<HTMLInputElement>): void {
    if (event != null) {
      const dontAskAgain: boolean = event.target.checked;
      this.setState({dontAskAgain: dontAskAgain});
      if (this.props.setDontAskAgain != null) {
        this.props.setDontAskAgain(dontAskAgain);
      }
    }
  }

  override render (): React.ReactNode {
    const {
      show, title, message, cancel, proceed,
      info, id, language,
      setDontAskAgain
    } = this.props;

    let { yesButtonText, noButtonText } = this.props;

    return (
      <Dialog
        id={'ae_dialog_confirm_' + id}
        show={show}
        language={language}
        title={title}
        useYesNo
        onShown={this.handleShown}
        onClose={() => cancel()}
        onConfirm={() => proceed()}
        closeText={noButtonText}
        confirmText={yesButtonText}
        primaryButton='confirm'
        extraFooterComponent={setDontAskAgain != null
          ? <div className='pull-left'>
            <CheckBox
              id={'ae_check_confirm_' + id + '_dontaskagain'}
              className='shared-checkbox-nopadding'
              checked={this.state.dontAskAgain}
              onChange={this.handleDontAskAgain}
              label={translate('shared.confirm.dontaskagain')} />
          </div>
          : undefined
        }
      >
        { message &&
          <>
            <p>{message.split('\n').map((item, key) =>
              <span key={key}>{item}<br /></span>
            )}</p>
            { info &&
              <p>{info.split('\n').map((item, key) =>
                <span key={key}>{item}<br /></span>
              )}</p>
            }
          </>
        }
      </Dialog>
    );
  }
}

export default confirmable(ConfirmDialog);
